import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");
  const role  = localStorage.getItem("adminRole"); // uses adminRole — never overwritten by owner login

  if (!token || role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedAdminRoute;
